<template>
<div class="ltshareList table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">联通随享订单列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="订单编号:">
                <el-input v-model="form.orderId" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="充值ICCID:">
                <el-input v-model="form.iccid" placeholder="请输入..."></el-input>
            </el-form-item>
            <el-form-item label="订单状态:">
                <el-select v-model="form.orderStatus" placeholder="请选择订单状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未支付" value="0"></el-option>
                    <el-option label="已支付" value="10"></el-option>
                    <el-option label="取消订单" value="50"></el-option>
                    <el-option label="退款中" value="60"></el-option>
                    <el-option label="已退款" value="80"></el-option>
                    <el-option label="已完成" value="90"></el-option>
                    <el-option label="已置换" value="120"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐类型:">
                <el-select v-model="form.packageType" placeholder="请选择套餐类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="普通套餐" value="1"></el-option>
                    <el-option label="叠加包加量包套餐" value="2"></el-option>
                    <el-option label="叠加包加速包套餐" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="代理商:">
                <el-select v-model="form.agentId" filterable placeholder="请选择代理商">
                    <el-option label="全部" value=""></el-option>
                    <el-option 
                        v-for="item in agentThreeLists" 
                        :key="item.agentId" 
                        :label="item.agentName" 
                        :value="item.agentId">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="开始时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.startTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item label="结束时间:">
                <el-date-picker type="datetime" placeholder="请选择日期时间" v-model="form.endTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportExcel">导出excel</el-button>
            </el-form-item>
        </el-form>
    </div>
    
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="业务订单编号" prop="orderSn" show-overflow-tooltip></el-table-column>
            <el-table-column label="订单编号" prop="orderId" show-overflow-tooltip></el-table-column>
            <el-table-column label="充值ICCID" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="订单提交时间" prop="createTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.createTime) }}
                </template>
            </el-table-column>
            <el-table-column label="支付时间" prop="payTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.payTime) }}
                </template>
            </el-table-column>
            <el-table-column label="完成时间" prop="finshTime" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatDateTime(scope.row.finshTime) }}
                </template>
            </el-table-column>
            <el-table-column label="流量(MB)" prop="flowTotal" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatFlow(scope.row.flowTotal) }}
                </template>
            </el-table-column>
            <el-table-column label="语音(MIN)" prop="voiceTotal" show-overflow-tooltip></el-table-column>
            <el-table-column label="总价(元)" prop="totalPrice" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatPrice(scope.row.totalPrice) }}
                </template>
            </el-table-column>
            <el-table-column label="订单状态" prop="orderStatus" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatOrderStatus(scope.row.orderStatus) }}
                </template>
            </el-table-column>
            <el-table-column label="套餐ID" prop="packageId" show-overflow-tooltip></el-table-column>
            <el-table-column label="套餐名称" prop="packageName" show-overflow-tooltip></el-table-column>
            <el-table-column label="套餐类型" prop="packageType" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ formatPackageType(scope.row.packageType) }}
                </template>
            </el-table-column>
            <el-table-column label="第三方用户ID" prop="thirdPartyUserId" show-overflow-tooltip></el-table-column>
            <el-table-column label="代理商名称" prop="agentName" show-overflow-tooltip></el-table-column>
        </el-table>
    </div>
    
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import { ltshareList, ltshareExport } from '@/api/ltshare/ltshareList.js'
import { agentListForUser } from '@/api/cardManagement/cardBill.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'

export default {
    name: 'ltshareList',
    mixins: [resize],
    data() {
        return {
            form: {
                orderId: '',
                iccid: '',
                orderStatus: '',
                packageType: '',
                agentId: '',
                startTime: '',
                endTime: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,
            agentThreeLists: []
        }
    },
    mounted() {
        this.getList()
        this.getAgentListForUser()
    },
    activated() {
        this.getList()
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            
            ltshareList(params).then(res => {
                if (res && res.page) {
                    this.tableData = res.page.rows || []
                    this.total = res.page.total || 0
                    this.currentPage = res.page.pageNo || 1
                }
            })
        },

        // 获取代理商列表
        getAgentListForUser() {
            agentListForUser().then(res => {
                console.log('代理商列表数据:', res)
                this.agentThreeLists = res || []
            })
        },

        // 搜索
        searchData() {
            this.currentPage = 1
            this.getList()
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getList()
        },

        // 导出
        exportExcel() {
            ltshareExport(this.form).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText:'确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list')
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },

        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            
            try {
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error('日期格式化错误:', error);
                return dateTime;
            }
        },

        // 格式化订单状态
        formatOrderStatus(status) {
            const statusMap = {
                '0': '未支付',
                '10': '已支付',
                '50': '取消订单',
                '60': '退款中',
                '80': '已退款',
                '90': '已完成',
                '120': '已置换'
            };
            return statusMap[status] || '-';
        },

        // 格式化套餐类型
        formatPackageType(type) {
            const typeMap = {
                '1': '普通套餐',
                '2': '叠加包加量包套餐',
                '3': '叠加包加速包套餐'
            };
            return typeMap[type] || '-';
        },

        // 格式化流量
        formatFlow(flow) {
            if (flow === null || flow === undefined) return '-';
            if (flow === -1) return '无限制';
            return parseFloat(flow).toFixed(2);
        },

        // 格式化价格
        formatPrice(price) {
            if (price === null || price === undefined) return '-';
            return parseFloat(price).toFixed(2);
        }
    }
}
</script>

<style scoped>
.ltshareList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}
</style>
